import {
  type CustomQueryOptions,
  type GetGlobalOfficeResponse,
  useGetGlobalOffice as useGetGlobalOfficeQuery,
  usePrefetch,
} from "@birdwatch/client";
import type { QueryClient } from "@tanstack/react-query";

export type GlobalOfficeData = GetGlobalOfficeResponse;

export const getGlobalOffice = async (
  queryClient: QueryClient,
): Promise<GlobalOfficeData | undefined> => {
  const cached = queryClient.getQueryData<{ data?: GlobalOfficeData }>(
    useGetGlobalOfficeQuery().getQueryKey(),
  );
  return cached?.data;
};

export const useGetGlobalOffice = (options?: CustomQueryOptions) =>
  useGetGlobalOfficeQuery().get({
    gcTime: Infinity,
    staleTime: Infinity,
    ...options,
  });

export const usePrefetchGlobalOffice = () => {
  const prefetch = usePrefetch();
  const builder = useGetGlobalOfficeQuery();

  return () => prefetch(builder);
};
